var outletCart = function () {
	"use strict";
	
	var tooltips = new toolTips(),
	cartAccordions = new getAccordions4i(),
	tinySlider, jsMessages, itemName, deleteDialog,
	cartId = document.getElementById('cartId').value,
	StartCountdownTime, EndCountdownTime = 0, CountdownTimerElement = "", CountdownIntervals = [],
	//antiForgeryToken = { "RequestVerificationToken": document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value },
	verificationToken = document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value,
	
	initPage = function () {
		tooltips.init();
		if (document.getElementById('divCartTable')) itemDetailsDialog.Init();

		if (document.getElementById("btnClearCart")) {
			document.getElementById("btnClearCart").addEventListener("click", function (e) {
				e.preventDefault();
				ajaxActions.ClearCart();
			});
		}
			
		if (document.getElementById("hottestScroller")){
			formEvents.InitializeScroller("hottestScroller");
		}else{
			cartAccordions.init(document.getElementById("mainContent"));
			deleteItemDialog.Init();
		}
		if(document.querySelectorAll(".requestTime").length > 0) formEvents.CountDownToTime();
	},

	ajaxActions = (function () {
		//Net Core does not like leading underscores on __RequestVerificationToken for the header
			
			let clearCart = function () {
				formEvents.ShowBusy();
					        			
				fetch('/cart/clearCart', { 
					method: 'POST', 
					body: JSON.stringify({ cartId: cartId }), 
					headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "RequestVerificationToken": verificationToken }
				}).then(function(response){
					return  (response.ok) ? response.json() : []; // response.json() returns a promise
				}).then(function(response){
					if (response.Success) {
						var isMessage = response.Message ? true : "";
						if (isMessage !== "") {
							//omniture.RemoveItem(response.Message);
						}
						formEvents.ReloadPage();
					} else {
						//formEvents.ShowAjaxMessage(response.Message);
							formEvents.HideBusy();
					}
					formEvents.ReloadPage();
				}).catch(function(error){
					//formEvents.ShowAjaxMessage(jsMessages.clearCartError);
					formEvents.HideBusy();
					formEvents.ReloadPage();
				});
			};



		return {
			ClearCart: clearCart
		};
	}()),

	formEvents = (function () {			
		var showBusy = function () {
			document.getElementsByClassName("loading")[0].classList.remove("hide");
		},

		hideBusy = function () {
			document.getElementsByClassName("loading")[0].classList.add("hide");
		},

		reloadPage = function () {
			location.reload(true);
		},

		showAjaxMessage = function (msg) {
			document.getElementById("divNotification").innerHTML = msg;
			document.getElementById("divNotification").classList.remove("hide");
			document.getElementById("divNotification").focus();
		},

		updateTimeLeft2 = function(element, index, timeDiff) {
    			var HoursLeft = (Math.floor((timeDiff / 60) / 60)).toString();
    			var MinutesLeft = (Math.floor((timeDiff / 60) % 60)).toString();
    			var SecondsLeft = (Math.floor(timeDiff % 60)).toString();
    			if (HoursLeft == 1 && MinutesLeft == 0 && SecondsLeft == 0) {
        						//UpdateDeals(DealID); //TODO
        					return;
    			}
    			if (HoursLeft.length < 2) { HoursLeft = '0' + HoursLeft; }
    			if (MinutesLeft.length < 2) { MinutesLeft = '0' + MinutesLeft; }
    			if (SecondsLeft.length < 2) { SecondsLeft = '0' + SecondsLeft; }
    				
    			if(element){
    				CountdownTimerElement = element.querySelectorAll(".countdownTime")[0];
    				setTicker(CountdownTimerElement, index, HoursLeft, MinutesLeft, SecondsLeft, timeDiff );
    			} 
    				else 
    			{
    				var alertBoxes = [].slice.call(document.querySelectorAll(".countdownTime"));
				alertBoxes.forEach(function(e){
					setTicker(e, index, HoursLeft, MinutesLeft, SecondsLeft );	
				});
			}
    		},
		
		setTicker = function(CountdownTimerElement, index, HoursLeft, MinutesLeft, SecondsLeft, timeDiff ){
    			if (HoursLeft == 0) {
        				if (MinutesLeft == 0) {
            				CountdownTimerElement.innerHTML = '00:00:' + SecondsLeft;
        				}else {
            				CountdownTimerElement.innerHTML = '00:' + MinutesLeft + ':' + SecondsLeft;
        				}
    			}else {
        				CountdownTimerElement.innerHTML = HoursLeft + ":" + MinutesLeft + ':' + SecondsLeft;
    			}
    			
    			clearInterval(CountdownIntervals[index]);
    			CountdownIntervals[index] = (setInterval(function() { updateTimeLeft2(CountdownTimerElement.closest(".dealTimer"), index, timeDiff-1); }, 1000));			
		},
		
		countDownToTime = function () {
			var alertBoxes = [].slice.call(document.querySelectorAll(".dealTimer"));
			alertBoxes.forEach(function(element, index){
					StartCountdownTime = new Date(element.querySelectorAll(".requestTime")[0].value);
					EndCountdownTime = new Date(element.querySelectorAll(".endTime")[0].value);
					var timeDiff = (EndCountdownTime.getTime() - StartCountdownTime.getTime()) / 1000;
					if (timeDiff > 0) {
    					CountdownIntervals.push(setInterval(function() { updateTimeLeft2(element, index, timeDiff);}, 1000));
					}
			});					
		},
		
		initializeScroller = function (sid) {
			var container = document.getElementById(sid),
				slider = container.querySelector('.Scroller');
			if (slider) {
				tinySlider = new tns({
					container: slider,
					mouseDrag: true,
					lazyload: true,
					prevButton: container.querySelector('.slider-prev'),
					nextButton: container.querySelector('.slider-next'),
					items: 2,
					gutter: 20,
					slideBy: "page",
					nav: false,
					navPosition: "bottom",
					loop: false,
					responsive: {
						1024: {
							items: 5,
							nav: true
						},
						800: {
							items: 4,
							nav: true
						},
						480: {
							items: 3
						}
					}
				});
			}
		};
		return {
			ShowBusy: showBusy,
			HideBusy: hideBusy,
			ReloadPage: reloadPage,
			ShowAjaxMessage : showAjaxMessage,
			CountDownToTime : countDownToTime,
			InitializeScroller: initializeScroller					
		};

	}()),

	deleteItemDialog = (function(){
		let deleteDialog, deleteCartItemId, removedProduct,
		
		init = () => {
			deleteDialog = new Dialog4i();
			deleteDialog.Init({
				triggerElements: [].slice.call(document.querySelectorAll(".cartDeleteBtn")),
				dialogClass: "smallDialog", 
				title: "Delete?", 
				content: getContent(), 
				onOpen: open
			});
		},
		getContent = () => {
			return '<div class="displayFlex flexJustifyEnd flexAlignItemsCenter">' +
				'<button id="btnConfirmCancel" class="close4iDialog btnToHyp underline text16 marginRight20" type="button">Cancel</button>' +
				'<button id="btnConfirmDelete" class="button-md bkgdBlue text16" type="button">Delete</button>' +
			'</div>';
		},
		open = (el) => {
			const productInfo = el.parentNode.parentNode.querySelector(".productInfo");
			itemName = productInfo.getAttribute("data-description");
			document.getElementById("popUpDialog").getElementsByTagName('h2')[0].innerHTML = "Delete " + itemName + "?";
			
			deleteCartItemId = el.getAttribute("data-cart-item-id");
			const alias = productInfo.getAttribute("data-catalog");
			const description = productInfo.getAttribute("data-description").replace("\"", "");
			const qty = productInfo.getAttribute("data-quantity");
			const price = productInfo.getAttribute("data-price");
			removedProduct = ";" + alias + " " + description + ";" + qty + ";" + price;				
			
			const submitBtn = document.getElementById("btnConfirmDelete");
			submitBtn.addEventListener("click", deleteItem);
		},
		deleteItem = (e) => {
			e.preventDefault();
			if (document.getElementById('divCartTable')) deleteCartItem();
		},
		deleteCartItem = (el) => {
			formEvents.ShowBusy();
			deleteDialog.Close();
			
			const cartData = { cartId: cartId, cartItemId: deleteCartItemId };

			//check if cartid and cartitemid are null
			if (cartId == null || deleteCartItemId == null) {
				formEvents.ReloadPage();
				return false;
			}
    			
			fetch('/cart/deletecartitem', { 
				method: 'POST', 
				body: JSON.stringify(cartData), 
				headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "RequestVerificationToken": verificationToken }
			}).then(function(response){
				return  (response.ok) ? response.json() : []; // response.json() returns a promise
			}).then(function(response){
				if (response.cartTotals.success && response.cartTotals.itemCount > 0) {
					fetch('/cart/getcartitemsview', { 
						method: 'POST', 
						body: JSON.stringify(cartData), 
						headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "RequestVerificationToken": verificationToken }
					}).then(function(response){
						return  (response.ok) ? response.text() : [];
					}).then(function(response){
						var divCartItems = document.getElementById("divCartItems");
						divCartItems.innerHTML = response;
						formEvents.HideBusy();
						document.getElementById("divCartTable").querySelector("a").focus();
					}).catch(function(error){
						console.log(error);
					}).finally(function(){
						omniture.DeleteCartItem(removedProduct);
						var cartItemCount = document.getElementById("cartItemCount");
						cartItemCount.innerHTML = "(" + response.cartTotals.itemCount + ")";
	
						var lblCartSubtotal = document.getElementById("lblCartSubtotal");
						var product = response.cartTotals.itemCount === 1 ? "product" : "products";
						lblCartSubtotal.innerHTML = "Subtotal (" + response.cartTotals.itemCount + " " + product + ")";
	
						var currCartSubtotal = document.getElementById("currCartSubtotal");
						currCartSubtotal.innerHTML = response.cartTotals.subTotal;
						
						document.querySelector("h1").textContent = "My Shopping Cart (" + response.cartTotals.itemCount + ")";
	
						deleteCartItemId = null;
						initPage();
					});
				} else {
					formEvents.ReloadPage();
				}
			}).catch(function(error){
				// place error handling here
			});
		};
		return{
			Init: init
		};
	})(),
	
	itemDetailsDialog = (function(){
		let detailsDialog,
		init = () => {
			detailsDialog = new Dialog4i();
			const loadingIcon = '<div class="spinner" role="alert" aria-busy="true" aria-atomic="true" aria-label="Loading example dialog, please wait"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>';
			detailsDialog.Init({
				triggerElements: [].slice.call(document.querySelectorAll(".cartDetailsBtn")),
				dialogClass: "divItemDetails smallDialog", 
				title: "Item Details", 
				content: loadingIcon, 
				onOpen: getItemDetails
			});
		},
		getItemDetails = (line) => {				        			
			fetch('/cart/itemdetails', { 
				method: 'POST', 
				body: JSON.stringify({ cartId: cartId, cartItemId: line.getAttribute("data-cart-item-id") }), 
				headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', "RequestVerificationToken": verificationToken }
			}).then(function(response){
				return  (response.ok) ? response.text() : [];
			}).then(function(response){
				const popup = document.getElementById('popUpDialog').querySelector(".dialogContent");
				popup.innerHTML = response;
			}).catch(function(error){
				formEvents.ShowAjaxMessage(jsMessages.getItemDetailsError);
				detailsDialog.Close();
			});
		};
		return{
			Init: init
		};
	})(),
	
	omniture = (function () {					
		var deleteCartItem = function (product) {
			const st = typeof s_gi === 'function' ? s_gi(s.account) : '';
			if(st)						
			{
				st.linkTrackVars = 'products,events';
				st.linkTrackEvents = 'scRemove';
				st.events = 'scRemove';
				st.products = product;
				st.t();
			}
		};

		return {
			DeleteCartItem: deleteCartItem
		};
	}());		
			
	return {
		Init: initPage
	};
};

(function () {
	var cart = new outletCart();
	cart.Init();
})();